import { observer } from "mobx-react";
import React, { Component } from 'react';
import 'Styles/userSettings/endOfSyncModal.scss';
import Enumerable from "linq";
import { SynchronizingStatus, SynchronizingTask } from "Utils/CommonFunctions";
import Helper from "Utils/Helper";
import UsersSyncStore from 'Stores/UsersSyncStore';
import LoadView from 'Components/Common/loadView';
import UserSettingsRequests from "Utils/Requests/UserSettingsRequests";

class EndOfSyncModal extends Component {
    render() {
        let userLid = this.props.userLid;
        let userState = UsersSyncStore.usersState[userLid];

        if (userState == null)
            return (<LoadView />);

        if (userState.status == SynchronizingStatus.dmsisDoesNotWorking)
            return (
                <div>
                    Синхронизация пользователя прервана!
                    Не удалось получить доступ к сервису интеграции.
                </div>
            );

        let lastSyncInfos = userState.lastSyncInfos;
        let lastSyncInfoFirst = lastSyncInfos.length > 0 ? lastSyncInfos[0] : null;

        let userDlsLastSyncInfos =
            Enumerable.from(lastSyncInfos)
                .where(lastSyncInfo => lastSyncInfo.userDLId != null)
                .toArray();

        let isMultipleUserDls = userDlsLastSyncInfos.length > 0;

        let userDLsCount =
            Enumerable.from(userDlsLastSyncInfos)
                .select(lastSyncInfo => lastSyncInfo.userDLId)
                .distinct()
                .count();
        let userDLsCountFinishedSuccessed =
            Enumerable.from(userDlsLastSyncInfos)
                .where(lastSyncInfo => lastSyncInfo.isSuccess == true)
                .select(lastSyncInfo => lastSyncInfo.userDLId)
                .distinct()
                .count();

        let grouppedLastSyncInfos =
            Enumerable.from(lastSyncInfos)
                .orderBy(lastSyncInfo => lastSyncInfo.task)
                .thenByDescending(lastSyncInfo => lastSyncInfo.userDLIsMain == true ? 1 : 0)
                .thenBy(lastSyncInfo => lastSyncInfo.userDLTitle)
                .groupBy(lastSyncInfo => lastSyncInfo.userDLTitle)
                .select(grp => {
                    let grpKey = grp.key();
                    let grpElements = grp.getSource();
                    return (grpKey && isMultipleUserDls)
                        ?
                        [{
                            groupTitle: grpKey,
                            htmlKey: grpElements[0].userDLId
                        }].concat(
                            grpElements
                        )
                        : grpElements
                        ;
                })
                .selectMany(it => it)
                .toArray();

        let toDisplayLastSyncInfos = grouppedLastSyncInfos;

        let syncInfoMainText = userState.status == SynchronizingStatus.cancelled
            ? "Синхронизация прервана. Пожалуйста, завершите процедуру синхронизации, чтобы пользователь мог продолжить работу без ошибок."
            : `Синхронизация пользователя завершена.`;
        let syncInfoDlsText = userDLsCount > 1 ? `Синхронизировано должностных лиц: ${userDLsCountFinishedSuccessed} из ${userDLsCount}.` : null;

        let styleUsePadding = true;

        if (lastSyncInfoFirst != null
            &&
            lastSyncInfoFirst.task == SynchronizingTask.removingUserDl
        ) {
            toDisplayLastSyncInfos = [];
            syncInfoMainText =
                lastSyncInfoFirst.isSuccess
                ? (<span>Должностное лицо <b>{Helper.StringTruncateToDisplayUserDlTitle(lastSyncInfoFirst.userDLTitle)}</b> успешно удалено, однако некоторые файлы и данные могут быть удалены автоматически позднее. Документы, соответствующие данному должностному лицу, будут удалены на устройстве после его синхронизации с СМР.</span>)
                    : (<span>Не удалось удалить должностное лицо</span>);
            syncInfoDlsText = null;
            styleUsePadding = false;
        }

        let foldersSyncInfo = [];
        toDisplayLastSyncInfos
            .forEach(x => {

                if (x.groupTitle != null) {
                    foldersSyncInfo.push(
                        <tr key={`folder_sync_info_title_userDLId_${x.htmlKey}`}>
                            <td className='folder-name-column row-group-title'>
                                {Helper.StringTruncateToDisplayUserDlTitle(x.groupTitle)}
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    );
                    return;
                }

                let folderName = 'Папка ';
                let result = '';

                switch (x.task) {
                    case SynchronizingTask.loadDictionaries:
                        let text = x.isSuccess === true ?
                            'Справочники пользователя успешно загружены на сервер.' :
                            'В процессе загрузки справочников произошла ошибка.';
                        foldersSyncInfo.push(
                            <tr key='folder_sync_info_title'>
                                <td className='folder-name-column'
                                    colSpan={3}>
                                    {text}
                                </td>
                            </tr>
                        );
                        return;
                    case SynchronizingTask.loadDocuments:
                    case SynchronizingTask.removeConsiderationDocuments:
                        folderName += '"На рассмотрение"';
                        break;
                    case SynchronizingTask.loadVisaDocuments:
                    case SynchronizingTask.removeVisaDocuments:
                        folderName += '"На визирование"';
                        break;
                    case SynchronizingTask.loadSignDocuments:
                    case SynchronizingTask.removeSignDocuments:
                        folderName += '"На подпись"';
                        break;
                    case SynchronizingTask.loadControlDocuments:
                    case SynchronizingTask.removeControlDocuments:
                        folderName += '"На контроле"';
                        break;
                    case SynchronizingTask.loadUserFolders:
                    case SynchronizingTask.removeUserFolders:
                        folderName = 'Избранные (личные папки)';
                        break;
                    case SynchronizingTask.loadDocumentsList:
                        folderName = 'В процессе загрузки списка документов произошел сбой. Проверьте раздел "Протоколирование" на предмет наличия ошибок, затем выполните синхронизацию еще раз.';
                        break;
                    case SynchronizingTask.loadProjectDocuments:
                    case SynchronizingTask.removeProjectDocuments:
                        folderName += '"Проекты документов"';
                        break;
                    case SynchronizingTask.loadMeetings:
                    case SynchronizingTask.removeMeetings:
                        folderName = 'События';
                        break;
                }

                if (x.isSuccess === true) {
                    switch (x.task) {
                        case SynchronizingTask.loadDocuments:
                        case SynchronizingTask.loadVisaDocuments:
                        case SynchronizingTask.loadSignDocuments:
                        case SynchronizingTask.loadControlDocuments:
                        case SynchronizingTask.loadProjectDocuments:
                            result = 'успешно синхронизирована';
                            break;
                        case SynchronizingTask.removeConsiderationDocuments:
                        case SynchronizingTask.removeVisaDocuments:
                        case SynchronizingTask.removeSignDocuments:
                        case SynchronizingTask.removeControlDocuments:
                        case SynchronizingTask.removeProjectDocuments:
                            result = 'успешно очищена'
                            break;
                        case SynchronizingTask.loadUserFolders:
                        case SynchronizingTask.loadMeetings:
                            result = 'успешно синхронизированы';
                            break;
                        case SynchronizingTask.removeUserFolders:
                        case SynchronizingTask.removeMeetings:
                            result = 'успешно очищены'
                            break;
                    }
                } else {
                    switch (x.task) {
                        case SynchronizingTask.loadDocuments:
                        case SynchronizingTask.loadVisaDocuments:
                        case SynchronizingTask.loadSignDocuments:
                        case SynchronizingTask.loadControlDocuments:
                        case SynchronizingTask.loadProjectDocuments:
                            result = 'синхронизирована с ошибками';
                            break;
                        case SynchronizingTask.removeVisaDocuments:
                        case SynchronizingTask.removeSignDocuments:
                        case SynchronizingTask.removeControlDocuments:
                        case SynchronizingTask.removeProjectDocuments:
                            result = 'очищена с ошибками'
                            break;
                        case SynchronizingTask.loadUserFolders:
                        case SynchronizingTask.loadMeetings:
                            result = 'синхронизированы с ошибками'
                            break;
                        case SynchronizingTask.removeUserFolders:
                        case SynchronizingTask.removeMeetings:
                            result = 'очищены с ошибками'
                            break;
                    }
                }

                if (result == null || result == "")
                    return;

                foldersSyncInfo.push(
                    <tr key={`folder_sync_info_${x.userDLId}_${folderName}_data`}>
                        <td className='folder-name-column'>{folderName}</td>
                        <td> - </td>
                        <td className='folder-status-column'>{result}</td>
                    </tr>
                )
            });

        let anomaly = userState.anomalyCounter > 0
            ? (
                <tr>
                    <td colSpan={2}
                        className='folder-name-column'>
                        {`Некорректно обработанных РК/РКПД: ${userState.anomalyCounter}`}
                    </td>
                    <td>
                        <button className='download-sync-anomalies-button'
                            onClick={() => UserSettingsRequests.GetAnomalies(userLid)}>
                            Выгрузить
                        </button>
                    </td>
                </tr>
            )
            : null
            ;

        return (
            <div style={styleUsePadding ? { padding: "20px" } : null}>
                <table className='result-table'>
                    <tbody>
                        <tr>
                            <td colSpan={3}>
                                {syncInfoMainText}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={3}>
                                {syncInfoDlsText}
                            </td>
                        </tr>
                        <tr className='filler-row' style={{ display: (foldersSyncInfo.length == 0 ? "none" : null) }} />
                        {foldersSyncInfo}
                        <tr className='filler-row' style={{ display: (anomaly == null ? "none" : null) }} />
                        {anomaly}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default observer(EndOfSyncModal);